'use strict';

import { getAnimScript } from './dataHelpers.js';
import { VarMgr } from './VarMgr.js';
import { ajaxWrapNew } from './ajaxWrapNew.js';
import { MapAnimator } from './MapAnimator.js';
import { wmmCalendarModal } from './modal/wmmCalendarModal.js';

/**
 * Palaiž animācijas funkciju nejaušos laika momentos, katram elementam no masīva.
 *
 * @param {Function} callback - Funkcija, ko izsaukt (saņems elementu, indeksu, kopējo skaitu)
 * @param {number} lengthSec - Kopējais laiks sekundēs (piem., 10)
 * @param {Array} itemsArray - Masīvs ar datiem/elementiem, ko izspēlēt
 */
function scheduleRandomAnimations(callback, lengthSec, itemsArray) {
    const count = itemsArray.length;

    if (count === 0) {
        //console.log("Masīvs ir tukšs, nav ko palaist.");
        return;
    }

    //console.log(`Kopējais laiks: ${lengthSec}s | Elementu skaits no masīva: ${count}`);

    const totalMilliseconds = lengthSec * 1000;
    const queue = [];

    // 1. Ģenerējam tikpat daudz unikālu un nejaušu laika momentu, cik ir elementu masīvā
    const timestamps = new Set();
    while (timestamps.size < count) {
        const randomTime = Math.floor(Math.random() * totalMilliseconds);
        timestamps.add(randomTime);
    }

    // Sakārtojam laikus hronoloģiskā secībā
    const sortedTimestamps = Array.from(timestamps).sort((a, b) => a - b);

    // Izveidojam queue priekš MapAnimator
    sortedTimestamps.forEach((ms, index) => {
        queue.push({ timestamp: ms, item: itemsArray[index] });
    });

    //console.log('Queue for MapAnimator:', queue);
    // Lietojam animatoru laika plānošanai un animāciju izpildei lai nolaižot tabu fonā nokavētās animācijas tiks skipotas
    const animator = new MapAnimator({
        playbackMilliseconds: true,
        queue: queue,
        delay: 0,
        paused: false,
        loop: false,
        serverNowTimestamp: 0,
        maxPlaybackTime: totalMilliseconds,
        missedOffset: -100, // par 100ms nokavētās netiks dzēstas;
        animate: (event) => {
            if (typeof callback === 'function') {
                callback(event.item, queue.indexOf(event), count, event.timestamp);
            }
        },
        finish: () => {
            animator.destroy();
        }
    });

    // Atgriežam objektu ar atcelšanas iespēju un grafika datiem (debug nolūkiem)
    return {
        cancel: () => {
            //console.log("Animāciju timeline tika atcelts.");
            animator.stop();
        },
        scheduleDetails: sortedTimestamps.map((ms, i) => ({
            timeSec: (ms / 1000).toFixed(2) + 's',
            item: itemsArray[i]
        }))
    };
}

export function initWMMAnimations() {

    const $mapAnimationNav = $('.mapAnimationNav');
    const $modeLive = $mapAnimationNav.find('.play-mode.live');
    const $modeRec = $mapAnimationNav.find('.play-mode.rec');
    const $modeUnavailable = $mapAnimationNav.find('.play-mode.unavailable');

    const unavailable = $mapAnimationNav.data('unavailable') == 1;
    const showUnavailable = () => {
        //$modeLive.removeClass('active').toggle(false);
        //$modeUnavailable.addClass('active').toggle(true);
        livePause();
        stopTest();
        $modeLive.animate({ opacity: 0 }, 300).promise().then(() => {
            $modeLive.removeClass('active').toggle(false);
            $modeUnavailable.css({ opacity: 0 }).addClass('active').toggle(true)
                .animate({ opacity: 1 }, 300);
        });
    };

    const liveConfig = VarMgr.get('liveConfig', {});
    const testConfig = VarMgr.get('testConfig', {});
    const timelapseConfig = VarMgr.get('timelapseConfig', {});

    const $liveBeamContainer = $('.liveContainer');
    const $liveBeamTemplate = $liveBeamContainer.find('.template');
    const $testBeamContainer = $('.testContainer');
    const $testBeamTemplate = $testBeamContainer.find('.template');
    const $recBeamContainer = $('.timelapseContainer');
    const $recBeamTemplate = $recBeamContainer.find('.template');

    const liveScript = getAnimScript(liveConfig.scriptId) || {};
    const testScript = getAnimScript(testConfig.scriptId) || {};
    const recScript = getAnimScript(timelapseConfig.scriptId) || {};

    const $testButton = $mapAnimationNav.find('.mapAnimBtn[data-type="test"]');
    const $playPauseStatusContainer = $mapAnimationNav.find('.playPauseStatusContainer');

    function getRndInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const state = {
        livePlaying: false,
        testPlaying: false,
        recPlaying: false,
        testInstance: null,
    }

    const createBeam = async (opt) => {
        return new Promise((resolve) => {
            const $item = opt.template.clone().removeClass('template');
            $item.css({
                left: opt.x + '%',
                top: opt.y + '%'
            });
            $item.appendTo(opt.container);

            const anim = new modAnimationRun({
                autoplay: false,
                prepare: true,
                groups: opt.script.groups,
                animations: opt.script.animations,

                animationContainer: '.beamAnimation'
            }, $item.get(0) );
            anim.onStop = () => {
                //console.log("Animation stopped for item:", $item);
                $item.remove();
                resolve();
            };
            anim.playStart();
        });
    };
    const createBeamWithInfo = async (opt) => {
        return new Promise((resolve) => {
            const $item = opt.template.clone().removeClass('template');
            $item.css({
                left: opt.x + '%',
                top: opt.y + '%'
            });
            $item.appendTo(opt.container);

            const optData = opt.data || {};
            const locationId = optData.id || 0;
            const countryId = optData.cid || 0;
            const isCity = locationId == countryId ? false : true;
            const $info = $('<div class="stm-star vBeam beamstar"></div>')
                .attr({
                    'title': optData.t || '',
                    'data-country': countryId,
                    'data-alias': optData.a || '',
                    'data-cnf': JSON.stringify(optData.s || [])
                });
            if (isCity) {
                $info.attr('data-city', locationId).addClass('iscity');
            } else {
                $info.addClass('iscountry');
            }
            $item.find('.animationFld').append($info);

            const anim = new modAnimationRun({
                autoplay: false,
                prepare: true,
                groups: opt.script.groups,
                animations: opt.script.animations,

                animationContainer: '.beamAnimation'
            }, $item.get(0) );
            anim.onStop = () => {
                //console.log("Animation stopped for item:", $item);
                $item.remove();
                resolve();
            };
            anim.playStart();
        });
    };

    let liveAnimator = null;
    const liveStart = () => {
        const isMs = true;
        //console.log('Izveidojam animatoru ar ', liveConfig.animdata);
        //console.log('Delay', liveConfig.delay, ' UpdateBefore', liveConfig.updatebefore);
        //console.log('Creating live MapAnimator with queue:', liveConfig.animdata.events || []);
        liveAnimator = new MapAnimator({
            playbackMilliseconds: isMs,

            queue: liveConfig.animdata.events || [],
            lastId: liveConfig.animdata.last_id,
            startPlayingAt: liveConfig.animdata.start_playing_at,
            serverNowTimestamp: liveConfig.animdata.server_now,

            delay: liveConfig.delay,
            fetchMargin: liveConfig.updatebefore,
            paused: false,
            loop: true,
            animate: (event) => {
                createBeamWithInfo({
                    type: 'live',
                    script: liveScript,
                    container: $liveBeamContainer,
                    template: $liveBeamTemplate,
                    x: event.x || 0,
                    y: event.y || 0,
                    data: event
                });
            },
            fetch: async (animator, lastId, lastFetchLimit, playbackTime, delay) => {
                //console.log('Fetching new animation data with lastId:', lastId, ' lastFetchLimit:', lastFetchLimit, ' playbackTime:', playbackTime, ' delay:', delay);
                const controller = new AbortController();
                const ajax = ajaxWrapNew({
                    url: liveConfig.fetchUrl,
                    method: 'GET',
                    data: {
                        last_id: lastId,
                        last_fetch_limit: lastFetchLimit,
                        lang_code: VarMgr.get('LANG_CODE'),
                        /* playback_time: playbackTime,
                        delay: delay,
                        isms: isMs ? 1 : 0 */
                    },
                    dataType: 'json',

                    silentErrors: ['ABORTED']
                });
                animator.setAbortController(controller);

                // Klausāmies uz signālu no AbortController
                controller.signal.addEventListener('abort', () => {
                    ajax.abort();
                });

                const data = await ajax;

                // Noņemam AbortController, jo pieprasījums ir pabeigts
                animator.setAbortController(null);

                if (data) {
                    if (data.ok) {
                        return data;
                    }
                    if (data.error) {
                        showToast(data.error);
                    }
                }

                // Apturam animāciju, ja nav jaunu datu
                return null;
            }
        });
    };

    const livePause = () => {
        if (liveAnimator !== null) {
            //console.log('Pausing live animation');
            liveAnimator.stop();
        }
    };

    const stopTest = () => {
        if (state.testInstance && typeof state.testInstance.stop === 'function') {
            state.testInstance.stop(true);
            state.testInstance = null;
        }
    };

    const liveResume = () => {
        if (liveAnimator === null) {
            //console.log('Starting live animation');
            liveStart();
        } else {
            //console.log('Resuming live animation');
            liveAnimator.start();
        }
    };

    const stopTestImmediately = true;
    const startTestAnimation = async () => {
        await new Promise(async (resolve) => {
            var interval;
            var thisIsFinished = false;
            state.testInstance = {
                stop: (force) => {
                    if (force) {
                        thisIsFinished = true;
                        clearInterval(interval);
                        $testButton
                            .attr('data-status', 'waiting')
                            .find('.runningDots').each(function() {
                                $(this).text('');
                            });
                        resolve();
                    }
                }
            }
            $testButton
                .attr('data-status', 'playing')
                .find('.runningDots').each(function() {
                    const $runningDots = $(this);
                    interval = setInterval(() => {
                        $runningDots.text($runningDots.text().length < 3 ? $runningDots.text() + '.' : '');
                    }, 500);
                });

            const delayPromise = new Promise((resolve) => setTimeout(resolve, testConfig.delay ?? 0));
            const animData = ajaxWrapNew({
                method: 'POST',
                data: {
                    ajax: 1,
                    action: 'test-animation',
                    length: testConfig.length || 10,
                    min: testConfig.min || 10,
                    max: testConfig.max || 100
                },
                dataType: 'json'
            });

            await Promise.all([delayPromise, animData]);
            const animResult = await animData;

            const withInfoData = animResult.withInfoData || false;
            const beamFunc = withInfoData ? createBeamWithInfo : createBeam;
            const length = animResult.length || testConfig.length || 10;
            const itemsArray = animResult.list || [];
            const beams = [];

            if (withInfoData && animResult.countries) {
                // Pievienojam info dinamiski par valsti priekš beam animācijām
                ConnectStatsMapState.addCountryData(animResult.countries);
            }

            if (thisIsFinished) {
                return;
            }
            state.testInstance = scheduleRandomAnimations((data, index, total, ms) => {
                const beam = beamFunc({
                    type: 'test',
                    script: testScript,
                    container: $testBeamContainer,
                    template: $testBeamTemplate,
                    x: data.x || 0,
                    y: data.y || 0,
                    data: data
                });
                beams.push(beam);
            }, length, itemsArray);

            var lengthPromiseResolve;
            const lengthPromise = new Promise((resolve) => {
                setTimeout(resolve, length * 1000);

                lengthPromiseResolve = resolve;
            });
            const stopTestInstance = (force) => {
                //console.log('Stopping test instance');
                if (force) {
                    if (state.testInstance && typeof state.testInstance.cancel === 'function') {
                        //console.log('Force stopping test instance');
                        state.testInstance.cancel();
                    }
                }
                if (lengthPromiseResolve) {
                    lengthPromiseResolve();
                }

                if (stopTestImmediately) {
                    finishTestInstance();
                }
            };
            const finishTestInstance = () => {
                clearInterval(interval);
                if (thisIsFinished) {
                    return;
                }
                thisIsFinished = true;
                $testButton
                    .attr('data-status', 'waiting')
                    .find('.runningDots').each(function() {
                        $(this).text('');
                    });

                resolve();
            };
            state.testInstance.promise = lengthPromise;
            state.testInstance.stop = stopTestInstance;

            // pagaidam kad animācija ir pabeigta un kad visas staru animācijas ir pabeigtas
            await lengthPromise;
            await Promise.all(beams);
            //console.log(`Test animation completed after ${length}ms`);
            stopTestInstance();
            finishTestInstance();
        });
    };

    const recPause = () => {
        $playPauseStatusContainer.attr('data-status', 'paused');
    };

    const recResume = () => {
        $playPauseStatusContainer.attr('data-status', 'playing');
    };

    const buttonActions = {
        live: function() {
            if (unavailable) { return showUnavailable(); };
            // uz live uzspiežot pārslēdz režīmu uz rec;
            //$modeLive.removeClass('active').toggle(false);
            //$modeRec.addClass('active').toggle(true);

            // pauzējam uzreiz;
            livePause();
            stopTest();
            $modeLive.animate({ opacity: 0 }, 300).promise().then(() => {
                $modeLive.removeClass('active').toggle(false);
                $modeRec.css({ opacity: 0 }).addClass('active').toggle(true)
                    .animate({ opacity: 1 }, 300).promise().then(() => {
                        // Animation completed
                    });
            });
        },
        test: function() {
            if (!state.testPlaying) {
                state.testPlaying = true;
                startTestAnimation().then(() => {
                    state.testPlaying = false;
                });
            } else {
                stopTest();
            }
        },
        rec: function() {
            // uz rec uzspiežot pārslēdz režīmu uz live;
            //$modeRec.removeClass('active').toggle(false);
            //$modeLive.addClass('active').toggle(true);
            //liveResume();

            $modeRec.animate({ opacity: 0 }, 300).promise().then(() => {
                $modeRec.removeClass('active').toggle(false);
                $modeLive.css({ opacity: 0 }).addClass('active').toggle(true)
                    .animate({ opacity: 1 }, 300).promise().then(() => {
                        // atsākam live animāciju kad pogas pārslēgušās lidz galam;
                        liveResume();
                    });
            });
        },
        playStart: function(btn) {
            recResume();
        },
        playPause: function(btn) {
            recPause();
        },

        recunavailable: function() {
            // uz rec unavailable uzspiežot pārslēdz režīmu uz live;
            //$modeUnavailable.removeClass('active').toggle(false);
            //$modeLive.addClass('active').toggle(true);
            //liveResume();

            $modeUnavailable.animate({ opacity: 0 }, 300).promise().then(() => {
                $modeUnavailable.removeClass('active').toggle(false);
                $modeLive.css({ opacity: 0 }).addClass('active').toggle(true)
                    .animate({ opacity: 1 }, 300).promise().then(() => {
                        // atsākam live animāciju kad pogas pārslēgušās lidz galam;
                        liveResume();
                    });
            });
        },
        unavailable: function() {
            // māris: uzejot ar peli - šis uzraksts kļūsts zils un kad uzspiež - uzraksts kļūst balts (tā pat kā aktivizēts Vision) tikai šim Coming soon nekas nenotiek - tikai uzdziest uz 3sec ja uzspiež un tad nodziest baltais.
            const $unavailableButton = $mapAnimationNav.find('.mapAnimBtn[data-type="unavailable"]');
            $unavailableButton.attr('data-status', 'playing')
                .promise().then(() => {
                    setTimeout(() => {
                        $unavailableButton
                            .attr('data-status', 'waiting');
                    }, 3000);
                });
        },

        openCalendar: function(btn) {
            // Atveram kalendāru
            // Šeit var pievienot kodu, kas atver kalendāra modālo logu
            wmmCalendarModal.init({
                button: btn,
                date: $(btn).data('date')
            });
        }
    }

    $mapAnimationNav.on('click', '.mapAnimBtn', function(event) {
        event.preventDefault();
        event.stopPropagation();

        if ($(this).hasClass('no-action')) { return; }

        const type = $(this).data('type');
        if (buttonActions[type]) {
            buttonActions[type](this);
        }
    });

    // Ja pieejams sākam LIVE animāciju
    if (!unavailable) {
        const autoplay = $mapAnimationNav.data('autoplay');
        if (autoplay == 'live') {
            liveStart();
        }
    };
}